import { render, staticRenderFns } from "./GA.vue?vue&type=template&id=9b83bb7c&scoped=true&"
import script from "./GA.vue?vue&type=script&lang=js&"
export * from "./GA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b83bb7c",
  null
  
)

component.options.__file = "GA.vue"
export default component.exports